import { Card, Skel } from "./ui";

function SkelCard({ lines = 2 }: { lines?: number }) {
  return (
    <Card hover={false} className="flex flex-col gap-3.5">
      <Skel w={110} h={12} />
      <Skel w={90} h={30} />
      {Array.from({ length: lines }).map((_, i) => (
        <Skel key={i} w={i === 0 ? "70%" : "45%"} h={12} />
      ))}
    </Card>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-3 gap-4">
        {Array.from({ length: 3 }).map((_, i) => (
          <SkelCard key={i} />
        ))}
      </div>
      <div className="flex flex-wrap gap-2.5">
        {[130, 150, 160, 70, 70, 70, 130].map((w, i) => (
          <Skel key={i} w={w} h={38} r={999} />
        ))}
      </div>
      <div className="grid grid-cols-[3fr_2fr] gap-4">
        <Card hover={false} className="flex h-80 flex-col gap-4">
          <Skel w={220} h={16} />
          <Skel w="100%" h={220} r={12} />
        </Card>
        <Card hover={false} className="flex h-80 flex-col gap-4">
          <Skel w={180} h={16} />
          {[0, 1, 2].map((i) => (
            <Skel key={i} w="100%" h={26} r={6} />
          ))}
        </Card>
      </div>
      <div className="grid grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkelCard key={i} />
        ))}
      </div>
    </div>
  );
}
